/**
 * Utility function to track form submission events based on form ID
 * @param {string} formId - The HubSpot form ID
 * @param {string} email - The user's email address
 */
export const trackFormSubmission = (formId, email) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  // Define form event mappings
  const formEventMap = {
    "b1f2fd0e-9b34-4a84-bf8d-c2ad4b28fd3e": "trial_form_submit",
    "c90a5ae1-1852-43f5-9346-a57837b9f470": "single_email_form_submit"
  };

  // Get the event name for the form ID
  const eventName = formEventMap[formId];
  
  // Only track if we have a valid event for this form ID
  if (eventName) {
    window.dataLayer.push({
      event: eventName,
      user_data: {
        email: email
      }
    });
  }
}; 